var _defs, _rect, _rect2, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _rect3, _polygon7, _polygon8, _polygon9, _polygon0, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNicLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2483c5;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "new_footer_nic-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -4.45,
    y: -3.33,
    width: 67.23,
    height: 67.23
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.06,
    y: 45.76,
    width: 7.32,
    height: 0.51
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.06 44.92 6.06 44.13 13.33 44.13 13.36 44.92 6.06 44.92"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.06 43.29 6.06 42.2 13.28 42.2 13.3 43.29 6.06 43.29"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.06 41.35 6.06 39.78 13.21 39.78 13.24 41.35 6.06 41.35"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.06 38.96 6.06 36.53 26.86 36.53 27.02 38.96 14.43 38.96 12.99 36.53 13.17 38.96 6.06 38.96"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.06 35.69 6.06 32.69 18.48 32.69 20.32 35.69 20.15 32.69 27.02 32.69 27.02 35.69 6.06 35.69"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.06 31.84 6.06 25.98 14.46 26.01 17.94 31.84 6.06 31.84"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 20.15,
    y: 25.98,
    width: 6.86,
    height: 5.86
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "27.02 39.78 27.02 41.35 16.03 41.35 14.99 39.78 27.02 39.78"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "27.02 42.2 27.02 43.29 17.29 43.29 16.58 42.2 27.02 42.2"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "27.02 44.13 27.02 44.92 18.37 44.92 17.85 44.13 27.02 44.13"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "27.02 45.76 27.02 46.26 19.26 46.26 18.92 45.76 27.02 45.76"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 28.97,
    y: 45.76,
    width: 7.17,
    height: 0.51
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 28.97,
    y: 44.13,
    width: 7.17,
    height: 0.79
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 28.97,
    y: 42.2,
    width: 7.17,
    height: 1.08
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 28.97,
    y: 39.78,
    width: 7.17,
    height: 1.57
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 28.97,
    y: 36.53,
    width: 7.17,
    height: 2.43
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 28.97,
    y: 32.69,
    width: 7.17,
    height: 3
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 28.97,
    y: 25.98,
    width: 7.17,
    height: 5.86
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.46,25.64h3.8v6.21H38.42a11.06,11.06,0,0,1,10-6.21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.12,32.69a4,4,0,0,0-1.43,3H37.47a10.34,10.34,0,0,1,.6-3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.75,36.53A4.06,4.06,0,0,0,46.18,39H37.89a9.75,9.75,0,0,1-.41-2.43Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.27,39.78v1.57H39a9.86,9.86,0,0,1-.79-1.57Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.27,42.2v1.08H40.49a10.26,10.26,0,0,1-.95-1.08Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.27,44.13v.79h-9.7a12.81,12.81,0,0,1-1.13-.79Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.27,45.76v.44H45.78s-.22.07-1.5-.44Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.55,22.64c-.18-.28-.66-1-1.62-2.31a28.52,28.52,0,0,1-1.69-2.53L42.43,17a4,4,0,0,0,.27.54.65.65,0,0,0,.48.35h0a.32.32,0,0,0,.32-.22.93.93,0,0,0,0-.22V15.63H41.89V14.3h3.93l-.18-.25-.12-.17a2.29,2.29,0,0,1-.3-1.24A1.91,1.91,0,0,1,46,11.15a3.07,3.07,0,0,1,1.94-.57,4.14,4.14,0,0,1,3,1.48,7.91,7.91,0,0,1,1.23,2.11V22.6H50.43v-7H48.8v7H47.11V19h-.72l-.71-1.25h1.43V15.63H45.24v2a1.4,1.4,0,0,1-.31.88,1.58,1.58,0,0,1-.92.61l-.23.06.15.19.67.84q.57.63,1.23,1.48Zm3.18-10.79-.27,0a1,1,0,0,0-.71.43,1.16,1.16,0,0,0-.18.66,1.22,1.22,0,0,0,.79,1.19,1.89,1.89,0,0,0,.62.16h1.76c.7,0,.7,0,.7-.16v0A3.2,3.2,0,0,0,47.73,11.85Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.77,23.22c-.21-.17-.45-.39-.7-.63l0,0h-.54a1.84,1.84,0,0,1-1.09-.36,1,1,0,0,1-.42-.83.91.91,0,0,1,.29-.68,1.08,1.08,0,0,1,.78-.27,1.34,1.34,0,0,1,.48.09,2.38,2.38,0,0,1,1.05.9.18.18,0,0,0,.15.07.69.69,0,0,0,.25-.07l.07,0a1.33,1.33,0,0,0,.51-.39,1.29,1.29,0,0,0,.25-1.08.41.41,0,0,0-.09-.19.27.27,0,0,0-.21-.1l-.11,0a2.42,2.42,0,0,0-.37.13l-.27.1a1.41,1.41,0,0,1-.42.06,1.81,1.81,0,0,1-.68-.14,2.6,2.6,0,0,1-.91-.68,2.64,2.64,0,0,1-.84-1.65.85.85,0,0,1,.32-.68,1,1,0,0,1,.69-.26H37.3v-.92H32.5v7H30.81v-7H29.24v7H27.55V19.4l-.19.08a.64.64,0,0,1-.25,0l-.21,0-.19,0,0,.2a2.23,2.23,0,0,1-.59,1.88,2.59,2.59,0,0,1-1.8.58,2.9,2.9,0,0,1-1.92-.84,6.52,6.52,0,0,1-1.71-2.53l1.23-.51.24.49a8.08,8.08,0,0,0,.48.9A2.36,2.36,0,0,0,24,20.71a1.32,1.32,0,0,0,.29,0,.88.88,0,0,0,.6-.2,1.14,1.14,0,0,0,.19-1.24,1.17,1.17,0,0,0-1-.62h-.69L23,17.79c.22-.06.56-.18.78-.26a1.19,1.19,0,0,0,.62-.45,1,1,0,0,0,.15-.54.71.71,0,0,0-.12-.43.66.66,0,0,0-.55-.26,1.5,1.5,0,0,0-.9.35,3.38,3.38,0,0,0-.51.5c-.35-.8-.52-1.19-.62-1.37L22,15.2a3.19,3.19,0,0,1,1.93-.66,2.37,2.37,0,0,1,1.59.54,1.68,1.68,0,0,1,.62,1.34,1.71,1.71,0,0,1-.44,1.23l-.15.16.2.09A2.41,2.41,0,0,1,26,18a1.46,1.46,0,0,0,.69.28h0s.78-.09.78-.35V14.3H37.67L37.42,14c-.26-.28-.7-.76-.76-.86a1.7,1.7,0,0,1-.25-1,1.79,1.79,0,0,1,1.23-1.57,2.92,2.92,0,0,1,.8-.12,1.63,1.63,0,0,1,.68.13c.5.23.54.38.45,1.19l-.06,0-.3-.1a2.24,2.24,0,0,0-.6-.1,1,1,0,0,0-.5.11.88.88,0,0,0-.44.67,1,1,0,0,0,.24.81l.17.21.18.22c.13.14.25.25.36.36l.22.21v3.45H35.59l.13.23s.24.42.32.53l.05.06a1.16,1.16,0,0,0,.56.45l.2,0a1.56,1.56,0,0,0,.55-.14l.09,0a3,3,0,0,1,1-.18,1.24,1.24,0,0,1,.63.13c.4.22.44.75.44,1.19a2.36,2.36,0,0,1-1.42,2.16l-.18.1-.25.12.23.15c.31.21,1.4.82,1.51.88l0,0-.93,1.06Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.24,24.37l-.14,0c-.23-.06-.38-.28-.52-.5l-.09-.13-.19-.28h.16a1,1,0,0,0,.31,0,.49.49,0,0,0,.22-.14.34.34,0,0,0,.07-.32.43.43,0,0,0-.18-.22l0,0-.32-.26L6.18,19.69V14.31H18.86c0,.85,0,8.29,0,8.29H17.17v-4h-2v.87a.76.76,0,0,1-.09.35.44.44,0,0,1-.44.29h0c-.13,0-.44-.13-1.14-1S12.6,18,12.6,17.92c0-.47.22-.68.71-.68h3.86V15.63H11.49v2.74a1.06,1.06,0,0,1-.4.86,1.65,1.65,0,0,1-1.09.42L8.72,18.58a2.42,2.42,0,0,0,.94-.13.29.29,0,0,0,.15-.32v-2.5h-2v3.69l1,.8,1.66,1.39.63.53a1.32,1.32,0,0,1,.54.9,1.07,1.07,0,0,1-.18.74,1.51,1.51,0,0,1-.4.38A1.61,1.61,0,0,1,10.24,24.37Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "16.04 14.3 19.82 14.3 19.82 15.63 18.29 15.63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNicLogo);
export default __webpack_public_path__ + "static/media/nic-logo.416eec6ae27d0b0713a3bc3200a04b25.svg";
export { ForwardRef as ReactComponent };